export const INTERNAL_LINK = [
  "primark.com",
  "www.primark.com",
  "corporate.primark.com",
];
